import { QRCodeSVG } from "qrcode.react";
import {useLogoChangeStore} from "../../../lib/store/useLogoChangeStore.tsx";

export default function DesktopLayout() {
    const { showPochenLogo } = useLogoChangeStore();
  return (
    <div className="py-[120px] flex-col justify-between hidden xl:flex">
        {showPochenLogo ? (
            <img className="w-[126px]" src="/icons/ic-pochen-ko-logo.webp" />
        ):(
            <img className="w-[126px]" src="/icons/ic-bi-logo.webp" />
        )}

      <div>
        <p className="text-[48px] font-bold pt-[13px]">
          파크골프가
          <br />
          쉬워지는 방법
        </p>
        <span className="text-[24px] text-[#888] font-[500] py-[24px]">
          보이스파크와 함께하세요
        </span>
      </div>
      <div className="w-[356px] flex-row p-[17px] bg-white gap-[46px] rounded-[15px]">
        <div className="relative">
            <QRCodeSVG
                className="w-[125px] h-[125px] top-0"
                value={"https://play.google.com/store/apps/details?id=com.fixelsoft.voicepark"}
            />
        </div>
        <p className="text-[18px] font-bold text-[#222]">
          <span className="text-primary">QR</span>찍고 앱에서
          <br />
          편하게 보세요.
        </p>
      </div>
    </div>
  );
}
